import React from "react";
import "@frameworks/web/stylesheets/components/generic/SuccessLinkPop.scss";
import loaderGIF from "@frameworks/web/assets/images/generic/loader-new-theme.gif";
import DeviceContext from "./customHooks/indentifyDevice";
const LoaderLinkPopUp = (props) => {
    const device = DeviceContext();
    return (React.createElement("div", { className: "loader-pop-link" },
        device && (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement("div", { className: "spl-head bg_aqua_white flexJustifySpaceBetween" },
            React.createElement("div", { className: "DMSansBold_20_700 txt-midnight-blue" }, props.Title))),
        React.createElement("div", { className: "spl-body taCenter" },
            React.createElement("img", { className: "loader", src: loaderGIF, alt: "loaderGIF" }),
            React.createElement("div", { className: `spl-text lh-140 DMSans_16_500 ${(device === null || device === void 0 ? void 0 : device.isDesktop) ? " txt-midnight-blue" : " txt_primaryGrey"}` }, props.messageReactNode))));
};
export default LoaderLinkPopUp;
